<template>
  <svg
    :width="size"
    :height="size"
    :viewBox="`0 0 ${size} ${size}`"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_4739_57821)">
      <path
        d="M6.78673 8.125L11.9485 3.25H13.669V22.75H11.9485L6.78673 17.875H1.625V8.125H6.78673Z"
        :fill="color"
      />
      <path
        d="M16.2615 8.125L19.7495 11.613L23.1558 8.20665L24.3049 9.3557L20.8986 12.762L24.3049 16.1683L23.1558 17.3174L19.7495 13.9111L16.2615 17.399L15.1125 16.25L18.6005 12.762L15.1125 9.27405L16.2615 8.125Z"
        :fill="color"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_4739_57821"
        x="-1"
        y="-1"
        width="30"
        height="30"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1" dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4739_57821"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4739_57821"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "i-volume-off",
  props: {
    size: {
      type: String | Number,
      default: "26"
    },
    color: {
      type: String,
      default: "white"
    }
  }
};
</script>

<style scoped lang="less">
svg {
  transition: all 0.5s;
  path {
    transition: all 0.5s;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/icons/play_control/volume_off.vue